module.exports = __webpack_public_path__ + "static/media/chevron-right-dark-grey.3df83ff1.svg";